import http from './http'

// 注册
export function register(data:any){
  return http({
    url:"/register",
    method:"POST",
    data
  })
}
// 登录
export function login(data:any){
  return http({
    url:"/login",
    method:"POST",
    data
  })
}
// 获取用户信息
export function userInfo(){
  return http({
    url:"/userInfo",
    method:"POST",
    closeLoading:true, //关闭loading
  })
}
// 修改登录密码
export function updatePassword(data:any){
  return http({
    url:"/password",
    method:"POST",
    data
  })
}
// 添加银行卡
export function userBank(data:any){
  return http({
    url:"/userBank",
    method:"POST",
    data
  })
}
// 银行卡列表
export function getUserBank(){
  return http({
    url:"/userBank",
    method:"GET",
  })
}
// 删除银行卡
export function delBank(data:any){
  return http({
    url:"/delBank",
    method:"POST",
    data
  })
}
// 用户提现
export function withdraw(data:any){
  return http({
    url:"/withdraw",
    method:"POST",
    data
  })
}
// 用户提现
export function withdrawInfo(data:any){
  return http({
    url:"/withdrawInfo",
    method:"POST",
    data
  })
}
// 设置/修改支付密码
export function payPassword(data:any){
  return http({
    url:"/payPassword",
    method:"POST",
    data
  })
}
// 贷款申请
export function postLoan(data:any){
  return http({
    url:"/postLoan",
    method:"POST",
    data
  })
}
// 贷款记录
export function loanInfo(data?:any){
  return http({
    url:"/loanInfo",
    method:"POST",
    data
  })
}
// 上传图片
export function upload(data:any){
  return http({
    url:"/upload",
    method:"POST",
    data
  })
}
// 实名认证
export function realNameAuth(data:any){
  return http({
    url:"/realNameAuth",
    method:"POST",
    data
  })
}
// ai交易界面内容
export function daytradingInfo(data:any){
  return http({
    url:"/daytradingInfo",
    method:"POST",
    data
  })
}
// ai交易订单
export function daytradingList(data:any){
  return http({
    url:"/daytradingList",
    method:"POST",
    data
  })
}
//ai交易提交
export function daytradingSubmit(data:any){
  return http({
    url:"/daytradingSubmit",
    method:"POST",
    data
  })
}

// otc交易界面内容
export function otcInfo(data:any){
  return http({
    url:"/otcInfo",
    method:"POST",
    data
  })
}
// otc记录列表
export function otcList(data:any){
  return http({
    url:"/otcList",
    method:"POST",
    data
  })
}
// otc缴纳
export function otcBuy(data:any){
  return http({
    url:"/otcBuy",
    method:"POST",
    data
  })
}
// otc订阅
export function otcSubmit(data:any){
  return http({
    url:"/otcSubmit",
    method:"POST",
    data
  })
}
// otc赎回
export function otcSell(data:any){
  return http({
    url:"/otcSell",
    method:"POST",
    data
  })
}

// 首页
export function home(data:any){
  return http({
    url:"/home",
    method:"POST",
    data
  })
}
// 股票列表
export function stockList(data:any,closeLoading:boolean){
  return http({
    url:"/stockList",
    method:"POST",
    closeLoading:closeLoading, //关闭loading
    data
  })
}
// 股票收藏/取消
export function stockToggle(data:any){
  return http({
    url:"/stockToggle",
    method:"POST",
    data
  })
}
// 收藏股票列表
export function stockListCollect(data:any){
  return http({
    url:"/stockListCollect",
    method:"POST",
    data
  })
}
// 指数
export function indexsList(data:any){
  return http({
    url:"/indexsList",
    method:"POST",
    data
  })
}
// ai订单详情
export function daytradingListLog(data:any){
  return http({
    url:"/daytradingListLog",
    method:"POST",
    data
  })
}
// 资金记录
export function finance(data:any){
  return http({
    url:"/finance",
    method:"POST",
    data
  })
}
// 股票详情
export function stockInfo(data:any){
  return http({
    url:"/stockInfo",
    method:"POST",
    data
  })
}
// 资讯列表
export function articleList(data:any){
  return http({
    url:"/newsList",
    method:"POST",
    isToken:false,
    data
  })
}
// ipo界面信息
export function ipoInfo(data:any){
  return http({
    url:"/ipoInfo",
    method:"POST",
    data
  })
}
// ipo列表
export function ipoList(data:any){
  return http({
    url:"/ipoList",
    method:"POST",
    data
  })
}
// ipo赎回
export function ipoSellApi(data:any){
  return http({
    url:"/ipoSell",
    method:"POST",
    data
  })
}
// etf界面信息
export function etfInfo(data:any){
  return http({
    url:"/etfInfo",
    method:"POST",
    data
  })
}
//  etf列表
export function etfList(data:any){
  return http({
    url:"/etfList",
    method:"POST",
    data
  })
}
//  客服获取
export function getService(data:any){
  return http({
    url:"/getService",
    method:"POST",
    data
  })
}
//  游客客服获取
export function getTempService(data:any){
  return http({
    url:"/getTempService",
    method:"POST",
    data
  })
}
//  通知
export function notices(data:any){
  return http({
    url:"/notices",
    method:"POST",
    data
  })
}
//  通知
export function getNotices(data:any){
  return http({
    url:"/getNotices",
    method:"POST",
    data
  })
}
//  地址绑定
export function updateAddress(data:any){
  return http({
    url:"/updateAddress",
    method:"POST",
    data
  })
}
//  股票买入
export function stockBuyOrder(data:any){
  return http({
    url:"/stockBuyOrder",
    method:"POST",
    data
  })
}
//  充值信息（选择充值方式后请求，传递pay_id和汇率percent）
export function getRecharge(data: any) {
  return http({
    url: "/rechargeInfo",
    method: "POST",
     data
  })
}
//  充值（根据选择的类型来显示不同的页面，qrcode/bank）
export function postRechargeQrcode(data: any) {
  return http({
    url: "/recharge",
    method: "POST",
    data
  })
}
//  领取体验金
export function trialBalance(data: any) {
  return http({
    url: "/trialBalance",
    method: "POST",
    data
  })
}
//  资产信息接口
export function userAssets(data: any) {
  return http({
    url: "/userAssets",
    method: "POST",
    data
  })
}
//  提现记录
export function withdrawList(data: any) {
  return http({
    url: "/withdrawList",
    method: "POST",
    data
  })
}
//  充值记录
export function rechargeList(data: any) {
  return http({
    url: "/rechargeList",
    method: "POST",
    data
  })
}
//用户通知已读（提交id）
export function readNoticeApi(data: any) {
  return http({
    url: "/readNotice",
    method: "POST",
    data
  })
}
//首页消息数量
export function getTips(data: any) {
  return http({
    url: "/getTips",
    method: "POST",
    data
  })
}
//单独股列表
export function stockOrder(data: any) {
  return http({
    url: "/stockOrder",
    method: "POST",
    data
  })
}
//单独卖出
export function stockSellOrder(data: any) {
  return http({
    url: "/stockSellOrder",
    method: "POST",
    data
  })
}
//  购买体验金ai
export function trialBalanceSubmit(data: any) {
  return http({
    url: "/trialBalanceSubmit",
    method: "POST",
    data
  })
}
//  获取最新的股票价格
export function stockPrice(data: any) {
  return http({
    url: "/stockPrice",
    method: "POST",
    closeLoading:true,
    closeErrorToast:true,
    data
  })
}
// 认购缴费
export function buyIpoInfoApi(data: any) {
  return http({
    url: "/ipoBuy",
    method: "POST",
    data
  })
}
// 提交订阅
export function subIpoInfoApi(data: any) {
  return http({
    url: "/ipoSubmit",
    method: "POST",
    data
  })
}
// 语言接口
export function langApi(data: any) {
  return http({
    url: "/lang",
    method: "POST",
    data
  })
}
// 指数详情
export function indexsInfoApi(data: any) {
  return http({
    url: "/indexsInfo",
    method: "POST",
    data
  })
}
// 欺诈鉴定提交
export function feedbackApi(data: any) {
  return http({
    url: "/feedback",
    method: "POST",
    data
  })
}
// 股票的请求k线数据的接口
export function indexsKlineApi(data: any) {
  return http({
    url: "/indexsKline",
    method: "POST",
    data
  })
}